import React from 'react';

import { SatInput } from '@components/common/satUI';

import { NOTICE_MAX_LENGTH } from '@common/constants';

/**
 * 계약이전고지화면표시방법코드 (A1)
 * 문구후 텍스트
 * @param {*} props
 * @returns
 */
const TextInputAfterAns = props => {
  const {
    isPreUw = false,
    group,
    items,
    tbNbsPolicyBfNtceAnsDtlDTO,
    tbNbsPolicyBfNtceAnsByitmDtlDTO,
    setTbNbsPolicyBfNtceAnsByitmDtlDTO,
    onSave,
  } = props;

  const onChange = (item, value) => {
    let newTbNbsPolicyBfNtceAnsByitmDtlDTO;
    if (
      tbNbsPolicyBfNtceAnsByitmDtlDTO.find(
        data =>
          data.policyBfNtceItmGrpNo === item.policyBfNtceItmGrpNo &&
          data.policyBfNtceItmNo === item.policyBfNtceItmNo,
      )
    ) {
      newTbNbsPolicyBfNtceAnsByitmDtlDTO = tbNbsPolicyBfNtceAnsByitmDtlDTO.map(
        data => {
          if (
            data.policyBfNtceItmGrpNo === item.policyBfNtceItmGrpNo &&
            data.policyBfNtceItmNo === item.policyBfNtceItmNo
          ) {
            return {
              ...data,
              ansContn: value,
            };
          }
          return data;
        },
      );
    } else {
      newTbNbsPolicyBfNtceAnsByitmDtlDTO = [
        ...tbNbsPolicyBfNtceAnsByitmDtlDTO,
        {
          ansContn: value,
          ansDataTyTpCd: '2',
          policyBfNtceId: '',
          policyBfNtceItmGrpNo: group.policyBfNtceItmGrpNo,
          policyBfNtceItmNo: item.policyBfNtceItmNo,
        },
      ];
    }
    setTbNbsPolicyBfNtceAnsByitmDtlDTO(newTbNbsPolicyBfNtceAnsByitmDtlDTO);
    onSave(
      value,
      { group, item },
      {
        tbNbsPolicyBfNtceAnsDtlDTO,
        tbNbsPolicyBfNtceAnsByitmDtlDTO: newTbNbsPolicyBfNtceAnsByitmDtlDTO,
      },
    );
  };

  const divide2 = items.find(({ dispMetaInfoList }) =>
    dispMetaInfoList.find(
      info =>
        info.displayLocation === 'answer' && info.displayMethod === 'readOnly',
    ),
  );

  return (
    <ul className="input-list">
      {items
        .reduce((acc, cur, idx, arr) => {
          if (divide2) {
            if (idx === arr.length - 1 || idx % 2 === 0) {
              acc.push([cur]);
            } else {
              const latest = acc.pop();
              latest.push(cur);
              acc.push(latest);
            }
          } else {
            acc.push([cur]);
          }

          return acc;
        }, [])
        .map(textGrp =>
          textGrp.map((item, idx) => {
            return (
              <li
                key={`text-grp-${idx}`}
                className={`${
                  textGrp.length === 2 ||
                  divide2?.policyBfNtceItmNo === item.policyBfNtceItmNo
                    ? 'divide-2'
                    : ''
                }`}
              >
                <SatInput
                  type="text"
                  disabled={isPreUw}
                  focusLabel={item.itmDispContn}
                  label={
                    item.dispMetaInfoList.find(
                      info => info.displayMethod === 'placeholder',
                    )?.dispContn || item.itmDispContn
                  }
                  maxLength={NOTICE_MAX_LENGTH[item.policyBfNtceInsLenContn]}
                  readOnly={
                    divide2?.policyBfNtceItmNo === item.policyBfNtceItmNo
                  }
                  value={
                    tbNbsPolicyBfNtceAnsByitmDtlDTO.find(
                      dtl =>
                        dtl.policyBfNtceItmGrpNo ===
                          group.policyBfNtceItmGrpNo &&
                        dtl.policyBfNtceItmNo === item.policyBfNtceItmNo,
                    )?.ansContn
                  }
                  onChange={value => {
                    onChange(item, value);
                  }}
                />
              </li>
            );
          }),
        )}
    </ul>
  );
};

export default TextInputAfterAns;
